<template>
  <div>
    <a-button
      type="primary"
      :style="{ margin: '0 0 24px 0' }"
      v-on:click="topage(`/home/ticketPackageAdmin/ticketPackageAddTwoAdmin?mode=1`)"
    >
      新增
    </a-button>
    <a-button type="danger" :style="{ margin: '0 0 24px 0' }" @click="dels" v-if="isStoreQuery ? true : false">
      批量删除
    </a-button>
    <a-table
      :columns="columns"
      :row-key="(record) => record.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      :row-selection="rowSelection"
      @change="handleTableChange"
    >
      <a-avatar slot="avatar" icon="user" />
      <span slot="memberStatus" slot-scope="text, record" v-if="record.isStoreQuery">
        <a-switch
          checked-children="上架"
          un-checked-children="下架"
          :checked="record.shelf === true ? true : false"
          @change="onChange(record)"
        />
      </span>
      <template slot="pic" slot-scope="pic">
        <img :src="pic" alt="" />
      </template>
      <template slot="limited1" slot-scope="text">
        <span> {{ text == 0 ? "不限购一份" : text == 1 ? "限购一份" : "" }} </span>
      </template>
      <template slot="shopName" slot-scope="text, record">
        <span v-if="record.storeList && record.storeList.length > 0">
          <span v-for="(item, index) in record.storeList" :key="index">
            {{ item.storeName }}<span v-if="index < record.storeList.length - 1">、</span>
          </span>
        </span>
        <span v-else>{{ record.shopName }}</span>
      </template>

      <template slot="packageType" slot-scope="text">
        <span v-if="text == 1" value="1">次数套餐</span>
        <span v-if="text == 2" value="2">年卡套餐</span>
        <span v-if="text == 3" value="3">月卡套餐</span>
        <span v-if="text == 4" value="4">季度卡套餐</span>
        <span v-if="text == 5" value="5">半年卡套餐</span>
        <span v-if="text == 6" value="6">门票套餐</span>
      </template>

      <template slot="operate" slot-scope="text, record">
        <a 
          v-if="record.isStoreQuery"
          href=""
          v-on:click.prevent="
            topage(
              `/home/ticketPackageAdmin/ticketPackageAddTwoAdmin?objId=${record.objId}&mode=2&storeId=${record.shopId}`
            )
          "
          >编辑</a
        >
        <span> \ </span>
        <a @click="del(record)" v-if="record.isStoreQuery">删除（单个门店）</a>
        <a @click="delByMerchantsId(record)" v-if="!record.isStoreQuery">删除（所有门店）</a>
        <span> \ </span>
        <a @click="onChangeMerchnats(record,true)" v-if="!record.isStoreQuery">上架（全部门店）</a>
        <span> \ </span>
        <a @click="onChangeMerchnats(record,false)" v-if="!record.isStoreQuery">下架（全部门店）</a>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  getTokensList,
  delTokensList,
  delsTokensList,
  getSeachList,
  storeUpdown,
  delTokensListByMerchantsId,
  storeUpdownByMerchants
} from "@/api/homeApi.js";
import { message } from "ant-design-vue";
const columns = [
  {
    title: "编号",
    dataIndex: "objId",
    sorter: true,
  },
  {
    title: "商品名称",
    dataIndex: "name",
    align: "center",
  },
  {
    title: "商品skuId",
    dataIndex: "skuId",
    align: "center",
  },
  {
    title: "封面图",
    dataIndex: "img",
    align: "center",
    scopedSlots: { customRender: "pic" },
  },
  {
    title: "门票类型",
    dataIndex: "packageType",
    align: "center",
    scopedSlots: { customRender: "packageType" },
  },
  {
    title: "所属门店",
    dataIndex: "shopName",
    align: "center",
    scopedSlots: { customRender: "shopName" },
  },
  {
    title: "上下架",
    dataIndex: "name",
    align: "center",
    scopedSlots: { customRender: "memberStatus" },
  },

  {
    title: "门市价",
    dataIndex: "priceShop",
    align: "center",
  },
  {
    title: "限购",
    dataIndex: "limited",
    align: "center",
    scopedSlots: { customRender: "limited1" },
  },
    {
    title: "套餐有效期/天",
    dataIndex: "validDate",
    align: "center",
  },
  {
    title: "支付价",
    dataIndex: "minSpecPrice",
    align: "center",
  },
  {
    title: "显示序号",
    dataIndex: "sortNum",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "operate",
    width: "15%",
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      data: [],
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      visible: false,
      isStoreQuery:false
    };
  },
  mounted() {
    console.log(this.$route.query.shopId);
    if(this.$route.query.shopId === 0){
      this.getTokensListData();
    }else if(this.formInline.shopId || this.$route.query.shopId >0){
      this.formInline.shopId = this.$route.query.shopId;
      this.query() 
    }else{
      this.getTokensListData();
    }
  },
  computed: {
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          this.$store.commit("setidList", selectedRowKeys);
          console.log(`selectedRowKeys: ${selectedRowKeys}`);
        },
      };
    },
  },
  props: ["formInline"],
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
        if(this.formInline.shopId>0){
        this.queryByStore();
        this.loading = false;
        return;
      }
      getTokensList(10, this.pagination.current, 653, 655).then((res) => {
        this.data = res.data;
      });
      this.loading = false;
    },
    getTokensListData() {
      this.loading = true;
      getTokensList(10, 1, 653, 655).then((res) => {
        this.loading = false;
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
     //
    onChangeMerchnats(row,isBoolean) {
      console.log(row);
      storeUpdownByMerchants(row.skuId, isBoolean).then((res) => {
        // this.getTokensListData();
        message.success(res.info);
      });
    },
    delByMerchantsId(row) {
      console.log(row);
      this.loading = true;
      delTokensListByMerchantsId(row.skuId).then((res) => {
        this.getTokensListData();
        this.loading = false;
        message.success(res.info);
      });
    },
    del(row) {
      console.log(row);
      this.loading = true;
      if(row.isStoreQuery){
        delTokensList(row.objId).then((res) => {
        this.queryByStore();
        message.success(res.info);
        this.loading = false;
      });
      }
    },
    dels() {
      let idList = this.$store.state.idList;
      delsTokensList(idList).then((res) => {
        this.queryByStore();
        message.success(res.info);
      });
    },
    //
    onChange(row) {
      console.log(row);
      if(row.isStoreQuery){
        storeUpdown(row.objId, true,row.shopId).then((res) => {
        this.queryByStore();
        message.success(res.info);
      });
      
      }
    },
     //
    onChangeMerchnats(row,isBoolean) {
      console.log(row);
      storeUpdownByMerchants(row.skuId, isBoolean).then((res) => {
        message.success(res.info);
      });
    },
    //
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
    queryByStore() {
      console.log(this.formInline);
      if(this.formInline.shopId == null || this.formInline.shopId == "" || this.formInline.shopId == undefined){
        this.formInline.shopId = 0
      }
      this.loading = true;
      getSeachList(
        this.pagination.pageSize,
        this.pagination.current,
        653,
        655,
        this.formInline.name,
        this.formInline.shopId
      ).then((res) => {
        this.loading = false;
        this.data = res.data;
        this.pagination.total = res.count;
        this.isStoreQuery = this.data[0].isStoreQuery ? true : false;
        console.log("query:", res);
      });
    },
    query() {
      console.log(this.formInline);
      if(this.formInline.shopId == null || this.formInline.shopId == "" || this.formInline.shopId == undefined){
        this.formInline.shopId = 0
      }
      this.loading = true;
      getSeachList(
        this.formInline.limit,
        this.formInline.page,
        653,
        655,
        this.formInline.name,
        this.formInline.shopId
      ).then((res) => {
        this.loading = false;
        this.data = res.data;
        this.pagination.total = res.count;
        this.isStoreQuery = this.data[0].isStoreQuery ? true : false;
      });
    },
  },
};
</script>
<style>
img {
  width: 110px;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/marketingManagement/AdminTicketPackage/ticketPackageHomeContent.vue